module.exports = __webpack_public_path__ + "img/Delete Subpackage.6ba9e6e9.png";